var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h1 font-weight-bold primary--text"},[_vm._t("default")],2),(_vm.divider)?_c('v-divider',{staticClass:"d-none d-lg-block"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }